import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_ORDER_GENERATE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_ORDER_GENERATE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_ORDER_GENERATE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/user-program-orders/generate`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
